import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import gele9 from "../../assets/gele9.png";
import gele4 from "../../assets/gele10.png";

import gele12 from "../../assets/gele12.png";
import gele15 from "../../assets/gele15.png";
import Aos from "aos";
function CarouselComponent(props) {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  });
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <Carousel
      responsive={responsive}
      arrows={false}
      infinite={true}
      autoPlay={true}
      autoPlaySpeed={1000}
      keyBoardControl={true}
      customTransition="all .5"
      showDots={true}
      renderDotsOutside={false}
      dotListClass="custom-dot-list-style"
    >
      <div
        data-aos="zoom-in"
        className="bg-gradient-to-r from-violet-500 to-fuchsia-500 w-[280px] lg:w-[350px] h-[350px]"
      >
        <img src={gele9} alt="" />
      </div>
      <div
        data-aos="flip-left"
        className="bg-gradient-to-r from-violet-500 to-fuchsia-500 w-[280px] lg:w-[350px] h-[350px]"
      >
        <img src={gele15} alt="" />
      </div>
      <div
        data-aos="flip-right"
        className="bg-gradient-to-r from-violet-500 to-fuchsia-500 w-[280px] lg:w-[350px] h-[350px]"
      >
        <img src={gele4} alt="" />
      </div>
      <div
        data-aos="zoom-out"
        className="bg-gradient-to-r from-cyan-500 to-blue-500 w-[280px] lg:w-[350px] h-[350px]"
      >
        <img src={gele12} alt="" />
      </div>
      <div
        data-aos="fade-in"
        className="bg-gradient-to-r from-cyan-500 to-blue-500 w-[280px] lg:w-[350px] h-[350px]"
      >
        <img src={gele15} alt="" />
      </div>
    </Carousel>
  );
}

export default CarouselComponent;
